import { ReactNode } from 'react';
import cn from 'classnames';
import styled from 'styled-components';

import { breakpoints, media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';
import { BFC } from '@/shared/types';
import { Icon, IconName } from '@/shared/uikit/Icon';

type WidgetContainerProps = {
  title?: string;
  subTitle?: string;
  header?: ReactNode;
  icon?: IconName;
  size?: 'default' | 'small';
  titleClassName?: string;
  childrenClassName?: string;
};

export const WidgetContainer: BFC<WidgetContainerProps> = ({
  children,
  title,
  subTitle,
  header,
  size,
  icon,
  titleClassName,
  childrenClassName,
  ...props
}) => {
  return (
    <Container {...props} className={cn(props.className, { small: size === 'small' })}>
      {title && (
        <TitleWrapper className={titleClassName}>
          {icon && (
            <IconWrapper>
              <Icon name={icon} size="s24" />
            </IconWrapper>
          )}
          <TextWrapper
            style={{
              width: size === 'small' ? 'auto' : '100%',
              flexDirection: size === 'small' ? 'column' : 'row',
              alignItems: size === 'small' ? 'flex-start' : 'center',
            }}
          >
            <b>{title}</b>
            {subTitle && <small>{subTitle}</small>}
          </TextWrapper>
        </TitleWrapper>
      )}
      {header}
      {children && <ChildrenWrapper className={childrenClassName}>{children}</ChildrenWrapper>}
    </Container>
  );
};

const Container = styled.div`
  background: ${COLORS.white};
  padding: 24px;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  &.small {
    padding: 8px 24px;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const IconWrapper = styled.div`
  color: ${COLORS.systemDark200};
  background: ${COLORS.systemLight200};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
`;

const ChildrenWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: auto;
`;

const TextWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  ${media.md}, ${breakpoints.sm} {
    align-items: center !important;
  }
`;
